"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ModuleActionPrimary = _interopRequireDefault(require("../Module/ModuleActionPrimary"));

var _ModuleActionbar = _interopRequireDefault(require("../Module/ModuleActionbar"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    minHeight: theme.spacing(7),
    userSelect: "none",
    "&[aria-expanded=true]": {
      minHeight: theme.spacing(8)
    }
  },
  primaryAction: {
    display: "flex",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    "& + $content": {
      marginLeft: 0
    }
  },
  actionbar: {
    display: "flex",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  content: {
    display: "flex",
    alignItems: "baseline",
    flexBasis: "100%",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    "&[data-editable=true]:hover": {
      cursor: "pointer"
    },
    "&[data-collapsible=true]:hover": {
      cursor: "pointer"
    }
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "normal",
    letterSpacing: 0
  },
  description: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "16px",
    fontWeight: "normal",
    letterSpacing: 0,
    opacity: ".6",
    marginLeft: theme.spacing(1)
  }
}));

const SectionHeader = (_ref) => {
  let title = _ref.title,
      _ref$untitled = _ref.untitled,
      untitled = _ref$untitled === void 0 ? "Untitled" : _ref$untitled,
      description = _ref.description,
      editable = _ref.editable,
      collapsible = _ref.collapsible,
      expanded = _ref.expanded,
      onToggle = _ref.onToggle,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "untitled", "description", "editable", "collapsible", "expanded", "onToggle"]);

  const classes = useStyles();
  return _react.default.createElement("header", {
    className: classes.root,
    "aria-expanded": expanded
  }, _react.default.createElement(_ModuleActionPrimary.default, _extends({}, props, {
    collapsible: collapsible,
    expanded: expanded,
    className: classes.primaryAction,
    onToggle: onToggle
  })), _react.default.createElement("div", {
    className: classes.content,
    "data-editable": editable,
    "data-collapsible": collapsible,
    onClick: onToggle
  }, _react.default.createElement(_Typography.default, {
    className: classes.title,
    component: "h2",
    noWrap: true
  }, title || untitled), description && _react.default.createElement(_Typography.default, {
    className: classes.description,
    component: "h3",
    noWrap: true
  }, description)), _react.default.createElement(_ModuleActionbar.default, _extends({}, props, {
    className: classes.actionbar
  })));
};

var _default = SectionHeader;
exports.default = _default;
module.exports = exports.default;